import React from 'react'

import { CheckboxProps } from './Checkbox.types'
import useInput from '../useInput'
import InputWrapper from '../InputWrapper/InputWrapper'
const Checkbox: React.FC<CheckboxProps> = (props) => {
    const context = useInput({ ...props }, 'boolean')
    const { value, isDisabled, onChange } = context
    const { size = 'md' } = props
    const classNames = () => {
        const c = ['r-checkbox', `r-size-${size}`]

        if (value) {
            c.push('r-state-checked')
        }
        if (isDisabled) {
            c.push('r-state-disabled')
        }

        return c.join(' ')
    }

    const handleToggle = (e) => {
        onChange(!value)
    }

    return (
        <InputWrapper
            {...context}
            onLabelClick={handleToggle}
            inputType={'checkbox'}
            className={'r-checkbox-input-wrapper'}
        >
            <div data-testid='Checkbox' className={classNames()} onClick={handleToggle}>
                <div className='r-checkmark' />
                <input
                    id={'input-' + name}
                    type='checkbox'
                    checked={value}
                    onChange={handleToggle}
                    style={{ display: 'none' }}
                />
            </div>
        </InputWrapper>
    )
}

export default Checkbox
